
import React from 'react'
import irelandApi from '../irelandApi';

export const getArticlesAboutIgnite = () => (dispatch) => {
    dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_PENDING', payload: []});
  
    return irelandApi.get('/api/about_ignite')
                     .then(function (response) {
                       dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_FULFILLED', payLoad: response.data.data});
                     })
                     .catch(function (error) {
                       dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_REJECTED', payLoad: error});
                     });
  };


// WEBPACK FOOTER //
// ./src/actions/about-ignite.js